import { App } from "./app";
import { render } from "solid-js/web";

import "./index.scss";

const app = document.getElementById("app");

if (app) {
  render(() => <App />, app);
}
